var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-secondary-3 border-radius--light py-3 px-4" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-4 border-right" },
          [
            _c("div", { staticClass: "mb-3" }, [
              _c("em", {
                staticClass:
                  "rounded-circle p-2 mr-2 color-primary-2 shadow bg-white",
                class: _vm.icon
              }),
              _c("span", [_vm._v(_vm._s(_vm.label.main))])
            ]),
            _c("custom-drop-down", {
              attrs: {
                "custom-error-msg": _vm.errorMsgs.dd,
                fieldkey: "id",
                fieldname: "name",
                label: _vm.label.dd,
                options: _vm.deselected,
                placeholder: "Seleccione"
              },
              on: { input: _vm.selectItem }
            }),
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-md-8 text-left" },
                [
                  _c("Link", {
                    staticClass: "ml-n1",
                    attrs: {
                      icon: "fas fa-plus-circle",
                      text: "Seleccionar todas"
                    },
                    on: {
                      click: function($event) {
                        return _vm.selectAll(true)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ],
          1
        ),
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-8" },
              [
                _c("custom-chips-group", {
                  staticClass: "mt-n3",
                  attrs: {
                    "no-background": "",
                    "no-wrap": true,
                    "object-text": "name",
                    "selected-items": _vm.selected,
                    title: _vm.label.selected
                  },
                  on: { itemMarkedForDeletion: _vm.unSelectItem }
                }),
                _vm.showError
                  ? _c("error", {
                      attrs: {
                        message: _vm.errorMsgs.badge,
                        variant: "no-border"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col d-flex justify-content-end" },
              [
                _c("action-button", {
                  staticClass: "mr-3 w-15",
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cerrar",
                    variant: "outline-danger"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("onClose")
                    }
                  }
                }),
                _c("action-button", {
                  staticClass: "w-15",
                  attrs: {
                    i: "fas fa-save",
                    text: "Guardar",
                    variant: "success"
                  },
                  on: {
                    click: function($event) {
                      return _vm.save(_vm.selected)
                    }
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 mt-4 col-md-3" },
              [
                _c("Link", {
                  attrs: {
                    color: "red",
                    icon: "fas fa-minus-circle",
                    text: "Eliminar todas"
                  },
                  on: {
                    click: function($event) {
                      return _vm.selectAll(false)
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }